<template>
  <div>
    <table class="table" style="font-size: 14px">
      <thead>
        <tr class="table-search">
          <td colspan="3" style="padding-top: 0; padding-left: 0px">
            <b-form-input v-model="search.name" class="search" placeholder="Tegund ástundun og hegðun" ref="focusInput" />
          </td>
          <td colspan="1" style="max-width: 80px">
            <div class="float-right" style="margin-top: -10px">
              <CustomButton type="create" title="Ný tegund" v-if="canEdit" @click.native="openSlidebar()" />
            </div>
          </td>
        </tr>
        <tr>
          <th>
            <LinkOrder title="Flokkur" :filteredList="getList" :list="list" column="type_name" />
          </th>
          <th>
            <LinkOrder title="Heiti" :filteredList="getList" :list="list" column="heiti_astundun" />
          </th>
          <th>
            <LinkOrder title="Virkt" :filteredList="getList" :list="list" column="virk" />
          </th>
          <th>
            <download-csv :data="getExcelData" :name="getExcelFileName" delimiter=";" class="cursor-pointer float-right">
              <i class="fa fa-file-excel-o excelText"></i>
            </download-csv>
          </th>
        </tr>
      </thead>
      <tbody>
        <TableRowLoader v-if="loading" colspan="4" :center="true" />
        <TableRowEmpty v-if="!loading && this.list.length === 0" colspan="4" :center="true" />
        <tr
          v-for="item in getList"
          :key="item.tegund_astundun_id"
          :class="{
            'active-table-row': selectedItem && selectedItem.tegund_astundun_id === item.tegund_astundun_id,
            'cursor-pointer': showSlidebar,
          }"
          @click="checkSlidebar(item)"
        >
          <td>{{ item.type_name }}</td>
          <td>{{ item.heiti_astundun }}</td>
          <td><yes-no :item="item.enabled"></yes-no></td>
          <td>
            <div class="float-right" v-if="canEdit">
              <b-btn variant="primary" class="mr-2 btn-xs" v-b-tooltip title="Breyta" @click.prevent="openSlidebar(item)">
                <i class="fa fa-pencil" />
              </b-btn>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <behavior-type-slidebar v-if="showSlidebar" :item="selectedItem" @closeSlidebar="closeSlidebar"> </behavior-type-slidebar>
  </div>
</template>

<script>
import types from '@/api/types';

import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

import CustomButton from '@/components/common/CustomButton.vue';
import YesNo from '@/components/common/YesNo.vue';

import TableRowLoader from '@/components/common/TableRowLoader.vue';
import TableRowEmpty from '@/components/common/TableRowEmpty.vue';
import LinkOrder from '@/components/common/LinkOrder.vue';

import BehaviorTypeSlidebar from '@/components/school/school/types/BehaviorTypeSlidebar.vue';

export default {
  name: 'behaviorType',
  components: {
    TableRowLoader,
    TableRowEmpty,
    LinkOrder,
    BehaviorTypeSlidebar,
    CustomButton,
    YesNo,
  },
  computed: {
    getList() {
      return this.list.filter(
        x =>
          this.search.name.length === 0 || (x.heiti_astundun && x.heiti_astundun.toUpperCase().startsWith(this.search.name.toUpperCase())),
      );
    },
    getExcelData() {
      const newList = [
        [],
        ['Tegundir ástundunar og hegðunar'],
        [],
        ['Heiti', 'Flokkur', 'Virkt'],
        ...this.getList.map(x => [x.heiti_astundun, x.type_name, x.enabled === 1 ? 'Já' : 'Nei']),
      ];
      return newList;
    },
    getExcelFileName() {
      return `tegund_astundun_hegdun_${moment().format('YYYYMMDD')}_${moment().format('HHmm')}.csv`;
    },
    canEdit() {
      return this.loggedInUserHasWritePermission('skolahald_uppbygging');
    },
    ...mapGetters(['loggedInUserHasReadPermission', 'loggedInUserHasWritePermission']),
  },
  data() {
    return {
      loading: false,
      showSlidebar: false,
      selectedItem: {},
      search: {
        name: '',
      },
      list: [],
    };
  },
  methods: {
    async loadList() {
      try {
        this.loading = true;
        const response = await types.getBehaviorList();
        this.list = response.data.items;
        this.$nextTick(() => {
          if (this.$refs.focusInput) {
            this.$refs.focusInput.focus();
          }
        });
      } catch (e) {
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.loading = false;
      }
    },
    openSlidebar(item) {
      this.selectedItem = item;
      this.showSlidebar = true;
    },
    closeSlidebar() {
      this.showSlidebar = false;
      this.selectedItem = {};
      this.loadList();
    },
    checkSlidebar(item) {
      if (this.showSlidebar) {
        this.openSlidebar(item);
      }
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
  created() {
    this.loadList();
  },
};
</script>
